import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Subjects from "./routes/Subjects";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "subject-settings",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "subject-settings" */ "./components"),
        import(
          /* webpackChunkName: "subject-settings" */ "./modules/SubjectSettingsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "subjectSettings",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Subjects(store)],
});
